import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconList } from '@tabler/icons-react';

/**
 * A button that allows the user to toggle an unordered list.
 */
export default function BulletList({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconList />}
      label="Nečíslovaný zoznam"
      active={editor?.isActive('bulletList')}
      shortcut="Ctrl + Shift + 8"
      onClick={() => editor?.chain().focus().toggleBulletList().run()}
    />
  );
}
